export default __webpack_public_path__ + "static/media/CloverLogo.58949c6b.svg";